import { FC } from 'react';

import { CommunicationRecipient } from 'types/Communication';

import TableRow from 'modules/_shared/Table/components/TableRow';
import { RowCell } from 'modules/_shared/Table/types/RowCell';
import {
  getDeliveredIp,
  getMailDeliveredDate,
  getMailStatus,
} from 'modules/communications/components/utils';
import { useTranslate } from 'hooks/useTranslate';

type RecipientsTableRowProps = {
  index: number;
  recipient: CommunicationRecipient;
  isResumeTable?: boolean;
};

const RecipientsTableRow: FC<RecipientsTableRowProps> = ({
  index,
  recipient,
  isResumeTable,
}) => {
  const { t } = useTranslate();

  const deliveredIp = getDeliveredIp(recipient);
  const deliveredDate = getMailDeliveredDate(recipient);
  const status = getMailStatus(recipient, t);

  const cells = [
    {
      key: `email-${index}`,
      content: recipient.email,
    },
    {
      key: `name-${index}`,
      content: recipient.name,
      hideOnMobile: true,
    },
    !isResumeTable
      ? {
          key: `delivered-ip-${index}`,
          content: deliveredIp,
          hideOnMobile: true,
        }
      : null,

    !isResumeTable
      ? {
          key: `delivered-date-${index}`,
          content: deliveredDate,
        }
      : null,
    {
      key: `status-${index}`,
      content: status,
    },
  ].filter(Boolean) as RowCell[];

  return <TableRow cells={cells} />;
};

export default RecipientsTableRow;
